import { useEffect } from "react";
import { isSynopsys } from "app/utils";

const useFavicon = () => {
  useEffect(() => {
    const { hostname } = window.location;
    const subdomain = hostname.split(".")[0];
    let faviconLink = "/favicon.ico";

    if (isSynopsys(subdomain)) faviconLink = "/favicons/synopsys.ico";

    const faviconElement = document.querySelector("link[rel=\"icon\"]");
    if (faviconElement) {
      (faviconElement as HTMLLinkElement).href = faviconLink; // Type assertion
    } else {
      const newFavicon = document.createElement("link");
      newFavicon.rel = "icon";
      newFavicon.href = faviconLink;
      document.head.appendChild(newFavicon);
    }
  }, []);
};

export default useFavicon;
